import { Card, Col, Divider, Typography, Row, Spin, Button, Space } from 'antd';
import React from 'react';
import { CompanyStats } from '../../../models/company-interface';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';
import VMDetail from '../components/VMDetail';
import { useParams } from 'react-router';

interface RouteParams {
  vmId: string;
}


export default function SkynetTranscriptionDetailPage() {

  const { vmId } = useParams<RouteParams>();
  const vmDetailQuery = CustomerServiceQueries.useTranscriptVMDetail(parseInt(vmId, 10));
  const { Title } = Typography;
  const updateEnableQuery = CustomerServiceQueries.useUpdateEnableTranscriptVM(parseInt(vmId, 10));
  const updateAlwaysOnQuery = CustomerServiceQueries.useUpdateTranscriptVMAlwaysOn(parseInt(vmId, 10));
  const updateStateQuery = CustomerServiceQueries.useUpdateTranscriptVMState(parseInt(vmId, 10));

  const handleChangeAlwaysOn = (enable: boolean) => {
    updateAlwaysOnQuery.mutate(enable);
  }

  const handleToggleEnable = (enable: boolean) => {
    updateEnableQuery.mutate(enable);
  }

  const handleToggleVMOn = (enable: boolean) => {
    updateStateQuery.mutate(enable);
  }

  return (
    <Spin spinning={vmDetailQuery.isLoading || updateEnableQuery.isLoading || updateAlwaysOnQuery.isLoading || updateStateQuery.isLoading}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Row>
            <Col flex="auto">
              <Title level={3}>
                Skynet - {vmDetailQuery.data?.deploymentName}
              </Title>
            </Col>
            <Col>
              <Space direction='horizontal'>
                <Button
                  onClick={() => {
                    handleToggleEnable(!vmDetailQuery.data?.enabled ?? false);
                  }}
                >
                  {vmDetailQuery.data?.enabled ? "Disable VM" : "Enable VM"}
                </Button>
                <Button
                  onClick={() => {
                    handleToggleVMOn(true);
                  }}
                >
                  Turn VM On
                </Button>
                <Button
                  onClick={() => {
                    handleToggleVMOn(false);
                  }}
                >
                  Turn VM Off
                </Button>
              </Space>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <VMDetail
            vmRecord={vmDetailQuery.data}
            pageIsLoading={vmDetailQuery.isLoading}
            isDetailPage={true}
            changeAlwaysOn={handleChangeAlwaysOn}
            isTranscription={true}
          />
        </Col>
      </Row>
    </Spin>
  );
}
